import React from 'react';
import ButtonBase from './ButtonBase';
import Asset from '../Asset';
import Box from '../Box/Box';
import { TButtonThirdParty } from './types/TButtons';

const getBrandIcon = (brand) => {
  switch (brand) {
    case 'facebook':
      return 'SocialBadgeFacebook';
    case 'google':
      return 'SocialBadgeGoogle';
    case 'apple':
      return 'SocialBadgeApple';
    case 'bancontact':
      return 'IconLogoBancontact';
    case 'ideal':
      return 'IconLogoIdeal';
  }
};

const getCustomClassName = (brand) => {
  switch (brand) {
    case 'google':
    case 'bancontact':
      return 'hz-IconWithBackground ';
    default:
      return '';
  }
};

const ThirdParty = ({ as = 'button', brand, children, ...rest }: TButtonThirdParty) => (
  <ButtonBase {...rest} as={as} kind="thirdParty" brand={brand}>
    <Box as="div" name="ThirdPartyIconContainer" className={getCustomClassName(brand)}>
      <Asset.Square name={`${getBrandIcon(brand)}`} size="m" inverse={true} />
    </Box>
    <Box as="div" name="ThirdPartyTextContainer">
      {children}
    </Box>
  </ButtonBase>
);

export default ThirdParty;
